import styled from "styled-components";

import close from "assets/Common/ReactModal/close.svg";

import vars from "variables";

const Root = styled.main`
  ul {
    font-size: 0.75rem;
  }

  li {
    width: 155px;
    margin-right: 10px;
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 15px;
  }

  li:hover {
    background: ${vars.colors.marineBlue};
  }

  .selected {
    color: white;
    background: ${vars.colors.blue} !important;
  }

  .remove {
    margin-left: auto;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    background: url(${close}) no-repeat;
    background-size: cover;
  }

  .remove:hover {
    border-radius: 20px;
    background-color: ${vars.colors.background};
  }

  .selected .remove:hover {
    background-color: #007acc;
  }

  ${vars.desktop.mediaQuery} {
    margin-top: -8px;
    padding-bottom: 14px;

    li {
      padding: 0 25px 0 12px;
    }

    .remove {
      top: calc(50% - 11px);
      right: 5px;
      width: 22px;
      height: 22px;
    }
  }

  ${vars.mobile.mediaQuery} {
    padding-bottom: 10px;

    li {
      margin-bottom: 4px;
      padding: 3px 16px 2px 12px;
      font-size: 0.8rem;
      font-weight: 700;
      border-radius: 13px;
    }

    .remove {
      top: calc(50% - 9px);
      right: 3px;
      width: 18px;
      height: 18px;
    }
  }
`;

export { Root };
